import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { Link, useLocation } from "react-router-dom";
import { db } from "../../../firebase";
import { Navbar } from "../../../Components/Navbar/Navbar";
import { Footer } from "../../../Components/Footer/footer";
import "./style.css";

interface PressRelease {
  id: string;
  title: string;
  content: string;
  date: string;
}

export function ComunicateDePresaPage() {
  const [headerImage, setHeaderImage] = useState("");
  const [pressReleases, setPressReleases] = useState<PressRelease[]>([]);
  const location = useLocation();

  useEffect(() => {
    const fetchData = async () => {
      const docRef = doc(db, "site_content", "press_page");
      const snap = await getDoc(docRef);
      if (snap.exists()) {
        const data = snap.data();
        setHeaderImage(data.header_image || "");
        const sortedReleases = (data.press_releases || []).sort(
          (a: PressRelease, b: PressRelease) =>
            new Date(b.date).getTime() - new Date(a.date).getTime()
        );
        setPressReleases(sortedReleases);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="page-container">
      <Navbar />
      {headerImage && (
        <div
          className="press-banner"
          style={{ backgroundImage: `url(${headerImage})` }}
        />
      )}
      <div className="page-content">
        <h1>Comunicate de presă</h1>
        <div className="press-list">
          {pressReleases.map((release) => (
            <Link
              key={release.id}
              to={`/comunicate/${release.id}${
                new URLSearchParams(location.search).get("admin") === "true" ? "?admin=true" : ""
              }`}
              className="press-card"
            >
              <h3>{release.title}</h3>
              <p className="press-date">
                {new Date(release.date).toLocaleDateString("ro-RO", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </p>
            </Link>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}
